import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { N30A, N40A, N900 } from '@atlaskit/theme/colors';
import { gridSize as gridSizeFn } from '@atlaskit/theme/constants';
import { HORIZONTAL_GLOBAL_NAV_HEIGHT } from '../../common/constants';
import { hexToRGBA } from '../../theme';
var gridSize = gridSizeFn();
export var containerCSS = function containerCSS(_ref) {
  var navigation = _ref.mode.navigation;
  return _objectSpread(_objectSpread({
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'space-between',
    paddingLeft: gridSize * 1.5,
    paddingRight: gridSize * 1.5,
    height: HORIZONTAL_GLOBAL_NAV_HEIGHT,
    position: 'relative'
  }, bottomShadow), navigation);
};
export var leftCSS = {
  alignItems: 'center',
  display: 'flex',
  flexGrow: 1,
  minWidth: 0,
  height: 'inherit',
  '& > *': {
    flexShrink: 0
  }
};
export var rightCSS = {
  alignItems: 'center',
  display: 'flex',
  flexShrink: 0,
  '& > *': {
    flexShrink: 0,
    marginRight: gridSize / 2
  }
};
export var bottomShadow = {
  '&::after': {
    content: '""',
    position: 'absolute',
    left: 0,
    right: 0,
    top: '100%',
    height: gridSize / 2,
    background: "linear-gradient(180deg, ".concat(N40A, " 0, ").concat(N40A, " 1px, ").concat(N30A, " 1px, ").concat(hexToRGBA(N900, 0), " 4px)")
  }
};